var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('section',{staticClass:"mt-10 mb-10"},[_c('h1',{staticClass:"font-size--24 text-center",staticStyle:{"word-break":"keep-all"}},[_vm._v(" 중복된 정보를 확인하고 있습니다."),_c('br'),_vm._v(" 운영팀 확인 후"),_c('br'),_vm._v(" 서비스 신청이 가능합니다. ")])])])
}]

export { render, staticRenderFns }